export default {"src":"/_next/static/media/favicon.2da50139.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};